var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-wrapper"},[_c('ValidationObserver',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var invalid = ref.invalid;
return [_c('form',{on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.validateFormData)}}},[_vm._t("default"),_vm._t("buttonSubmit",null,{"invalid":invalid})],2)]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }